export default __webpack_public_path__ + "static/media/tourSectionBg.d32c270c.png";